import { ReactNode } from 'react';

export enum DoqType {
  SIMPLE = 1,
  ALGORITHM,
  ERROR,
  BROADCAST,
  SUCCESS,
  ALARM,
  LOCKED,
  DEPENDENCY_MAP_ERROR,
  BLOCK_DIAGRAM_ERROR,
  RELATIONSHIPS_ERROR,
  PAGE_GONE,
  COMPONENT_MERGE_EMPTY,
  CHOOSE_ORG,
  MISSING_ORG,
  RELATIONSHIPS_GONE,
  DEPENDENCY_MAP_GONE,
  SPIDER_CHART,
  DASHBOARD_BELLY_SIMPLE,
  DASHBOARD_BELLY_MISSING_ORG,
  DEPENDENCY_WHEEL_ERROR,
  TREEMAP_ERROR,
  DEPENDENCY_MATRIX_ERROR,
  BUBBLE_CHART_ERROR,
  CAPABILITY_MAP_ERROR,
  COMPONENT_MATRIX_ERROR,
  COMPONENT_TREE_ERROR,
  PAGE_VIEW_ERROR,
  REFERENCE_TABLE_ERROR,
  SWIMLANE_ERROR,
  TABLE_ERROR,
  TAGSCAPE_ERROR,
  TIMELINE_ERROR,
  DROPZONE_INITIAL,
  DROPZONE_DRAGOVER,
  DROPZONE_UPLOADING,
  DROPZONE_SUCCESS,
  DROPZONE_INVALID,
  DROPZONE_ERROR,
  NO_ACCESS,
  WAITING,
  IMPORT_SUCCESS,
  HEADPHONES,
  EMPTY_BOX,
}

export enum DoqLayout {
  DIALOG = 'dialog',
  PAGE = 'page',
  VERTICAL = 'vertical',
}

export enum DoqSize {
  EXTRA_SMALL = 96,
  SMALL = 144,
  PETIT_MEDIUM = 200,
  MEDIUM = 240,
  BIG = 320,
}

export type DoqWithSpeechBubbleProps = {
  doqType?: DoqType;
  title?: string;
  message?: React.ReactNode;
  layout?: DoqLayout;
  buttonLabel?: ReactNode;
  onButtonClick?: () => void;
  extraButton?: React.ReactElement;
  buttonClickId?: string;
};

export type DoqFaceSvgProps = {
  size?: number;
  className?: string;
  isAnimated?: boolean;
};

export type SpeechBubbleProps = {
  title?: string;
  layout?: DoqLayout;
};
